import React, { Component } from "react";
import { UserContext } from "../../Context";
import ProfileFormEmploymentAdd from "../profileFormEmploymentAdd/ProfileFormEmploymentAdd";

import "./profileFormEmployment.css";
import ProfileFormEmploymentCard from "../profileFormEmploymentCard/ProfileFormEmploymentCard";

const TYPES = {
  _current: "Current",
  _previous: "Previous"
};
export default class ProfileFormEmployment extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {userContext => (
          <div className="profile-form-employment">
            {userContext.my && userContext.my.currentEmployment ? (
              <ProfileFormEmploymentCard
                userContext={userContext}
                type={TYPES._current}
                employment={userContext.my.currentEmployment}
              />
            ) : (
              <ProfileFormEmploymentAdd
                userContext={userContext}
                type={TYPES._current}
              />
            )}
          </div>
        )}
      </UserContext.Consumer>
    );
  }
}

// {
//   <hr />
//   {
//   userContext.my && userContext.my.previousEmployment ? (
//     <ProfileFormEmploymentCard
//       userContext={userContext}
//       type={TYPES._previous}
//       employment={userContext.my.previousEmployment}
//     />
//   ) : (
//       <ProfileFormEmploymentAdd
//         userContext={userContext}
//         type={TYPES._previous}
//       />
//     )
//   }
// }



// WEBPACK FOOTER //
// ./src/components/profileFormEmployment/ProfileFormEmployment.js